<template>
  <div class="h-full" ref="minArea">
    <div class="h-full" :style="minAreaStyle">
      <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
        <el-row type="flex" align="middle" class="survey-point__header">
          <selectStandardId @updateStandardId="updateStandardId" />
          <el-input
            v-model="keyword"
            size="small"
            clearable
            :placeholder="$t('测点编码或测点名称')"
            @keyup.native.enter="searchData"
            class="w-200px mr-10px ml-10px"
          ></el-input>
          <el-button type="primary" @click="searchData">{{ $t('search') }}</el-button>
          <el-button
            :disabled="!$hasAccess('create')"
            type="primary"
            @click="$refs.pointDetail.openPointDialog('add', null)"
            >{{ $t('create') }}</el-button
          >
          <el-button :disabled="!$hasAccess('delete')" type="danger" @click="deleteData(ids)">{{
            $t('delete')
          }}</el-button>
          <el-button
            :disabled="!$hasAccess('export')"
            @click="downloadExcel"
            :loading="exportLoading"
            >{{ $t('export') }}</el-button
          >
          <el-button :disabled="!$hasAccess('import')" @click="importFile">{{
            $t('import')
          }}</el-button>
        </el-row>
        <div v-loading="initLoading" class="mt-20px" style="height: calc(100% - 106px)">
          <el-table :data="tableData" border stripe height="100%" @selection-change="getDataIds">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              :label="$t('测点编码')"
              prop="code"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$t('测点名称')"
              prop="name"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$t('单位')"
              prop="unit"
              width="100px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$t('测点周期')"
              prop="cycle"
              width="110px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.cycle !== -1 ? scope.row.cycle : '' }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('测点类型')"
              prop="type"
              width="100px"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{
                  _.find(pointType, { value: scope.row.type })
                    ? _.find(pointType, { value: scope.row.type }).name
                    : ''
                }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('测点驱动')"
              prop="driveName"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column :label="$t('操作')" width="200">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="$refs.pointDetail.openPointDialog('show', scope.row, 'id')"
                  :disabled="!$hasAccess('read')"
                  >{{ $t('view') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click="$refs.pointDetail.openPointDialog('edit', scope.row, 'id')"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete')"
                  size="mini"
                  @click="deleteData([scope.row.id])"
                  >{{ $t('delete') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="mt-20px float-right"
          background
          @size-change="searchData"
          @current-change="initData"
          :current-page.sync="pageNo"
          :page-sizes="$pageSizeAll"
          layout="total, sizes, prev, pager, next"
          :page-size.sync="pageSize"
          :total="pageTotal"
          :pager-count="5"
        ></el-pagination>
      </el-card>
      <point-detail ref="pointDetail" @submit="initData" :standardId="standardId"></point-detail>
    </div>
    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchData"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </div>
</template>

<script type="text/babel">
import ApiMixinPoint from '@/assets/js/api/measuringPoint'
import ApiMixinDictionaryManagement from '@/assets/js/api/dictionaryManagement'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'
import pointDetail from '../../components/pointDetail'

export default {
  name: 'point',
  components: { pointDetail, selectStandardId },
  mixins: [ApiMixinPoint, ApiMixinDictionaryManagement, fnMixin],
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      minAreaStyle: {},
      keyword: '',
      initLoading: false,
      tableData: [],
      pointType: [
        { value: 1, name: '模拟量' },
        { value: 2, name: '开关量' },
        // { value: 3, name: '逻辑模拟量PI' },
      ],
      pageSize: 15,
      pageNo: 1,
      pageTotal: 0,
      ids: [],
      exportLoading: false,
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      pointIds: [],
    }
  },
  computed: {
    fromOtherSystem() {
      return this.$store.getters['Origin/fromOtherSystem']
    },
    currentProject() {
      return this.$store.getters['Sites/currentProject'] || {}
    },
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  async created() {
    if (this.standardId) {
      await this.initData()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  methods: {
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await this.apiPoint({ method: 'template' })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '测点导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await this.apiPoint({
        method: 'upload',
        formData,
      })
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '测点导入明细.xlsx',
          data: res,
        })
        this.searchData()
      }
      this.uploadFileProps.btnLoading = false
    },
    updateStandardId(val) {
      this.standardId = val
    },
    setMinAreaStyle() {
      const width = `${this.$refs.minArea.offsetWidth}px`
      const height = `${this.$refs.minArea.offsetHeight}px`
      return { 'min-width': width, 'min-height': height, overflow: 'hidden' }
    },
    // 搜索
    async searchData() {
      if (this.pageNo !== 1) {
        this.pageNo = 1
      }
      await this.initData()
    },
    // 初始化数据
    async initData() {
      this.initLoading = true
      const res = await this.apiPoint({
        method: 'list',
        params: {
          MaxResultCount: this.pageSize,
          SkipCount: this.pageNo,
          // status: 0,
          StandardId: this.standardId,
          SearchText: this.keyword,
          Category: 0,
        },
      })
      this.initLoading = false
      if (res && res.code === 0 && res.data && res.data.length) {
        this.tableData = res.data
        this.pageTotal = res.totalCount
      } else {
        this.tableData = []
        this.pageTotal = 0
      }
    },
    // 重置
    async resetFilterData() {
      this.keyword = ''
      await this.initData()
    },
    // 表格多选
    getDataIds(selection) {
      this.ids = []
      this.ids = _.map(selection, (item) => {
        return item.id
      })
      this.pointIds = _.map(selection, (item) => {
        return item.pointId
      })
    },
    // 删除表格数据
    deleteData(ids) {
      if (ids.length) {
        this.$confirm('是否删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.initLoading = true
            const res = await this.apiPoint({ method: 'delete', params: { ids } })
            this.initLoading = false
            if (res && res.code === 0) {
              this.$message.success('删除成功')
              if (this.tableData.length === ids.length && this.pageNo > 1) {
                this.pageNo -= 1
              }
              this.ids = []
              await this.initData()
            }
          })
          .catch()
      } else {
        this.$message.info('请选择要删除的数据')
      }
    },
    // 导出
    async downloadExcel() {
      const params = {
        // status: 0,
        standardId: this.standardId,
        searchText: this.keyword,
        category: 0,
      }
      if (!this.keyword && !this.pointIds.length) {
        this.$confirm(
          '当前没有选中任何记录,系统将默认导出系统中所有数据,该操作时间会比较长,请确认是否要继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(async () => {
            this.exportLoading = true
            const res = await this.apiPoint({ method: 'download', params })
            this.exportLoading = false
            if (res) {
              this.downLoadExcel('测点清单导出结果.xlsx', res)
            }
          })
          .catch(() => {
            this.exportLoading = false
          })
      } else {
        this.exportLoading = true
        if (this.keyword) {
          params.searchText = this.keyword
        }
        if (this.pointIds.length) {
          params.pointIds = this.pointIds
        }
        const res = await this.apiPoint({ method: 'download', params })
        this.exportLoading = false
        if (res) {
          this.downLoadExcel('测点清单导出结果.xlsx', res)
        }
      }
    },
  },
  mounted() {
    this.minAreaStyle = this.setMinAreaStyle()
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>

</style>
